import React from 'react';
import TextCenter from '../../../../components/TextComps/TextCenter';
export default function CVDGeneticsText() {
  
  return (
<>
    <TextCenter 

      text={'Book a counselling session to evaluate your genetic cardiovascular profile '}    
      
    
    />
      
    
</>
   )
}